import { PricingTiers } from '../../SharedArea/PricingTiers/PricingTiers';

/**
 * Buying the subscription from inside the app.
 *
 * The tier grid, the Paddle.js loading and the checkout wiring all live in
 * the shared component the public pricing page also uses, so there is one
 * place that knows how to open a Paddle checkout rather than two drifting
 * copies. Unlike the pricing page, this one stays on the same screen and
 * re-reads the subscription once the overlay reports a completed checkout,
 * because the tutor is already signed in and already looking at their
 * account: there is nowhere more useful to send them.
 */
export function PaddleCheckout({ onPurchased }: { onPurchased: () => void }) {
  return <PricingTiers onPurchased={onPurchased} />;
}
